import React from "react";
import { Link } from "react-router-dom";
import { services, industries } from "@/lib/data";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-panel text-bg grain grain-dark relative">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-24 pb-10">
                <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-line-2">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-8">
                            <img src="/brand/logo-fct.png" alt="Final Cut Technologies" className="w-14 h-14 object-contain" />
                            <div className="leading-tight">
                                <p className="font-display text-lg text-bg">Final Cut Technologies</p>
                                <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-gold">Metro Vancouver · BC</p>
                            </div>
                        </div>
                        <p className="eyebrow text-bg/50">Ready when you are</p>
                        <h3 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight mt-6">
                            Let's make your business technology easier to manage.
                        </h3>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <Link to="/contact" className="inline-flex items-center gap-2 bg-bg text-ink px-5 py-3 text-sm font-medium hover:bg-gold hover:text-ink transition-colors duration-300">
                                Request a Site Assessment <ArrowUpRight className="w-4 h-4" />
                            </Link>
                            <a href="tel:+16046714247" className="inline-flex items-center gap-2 border border-bg/40 text-bg px-5 py-3 text-sm hover:border-gold hover:text-gold transition-colors duration-300 font-mono tracking-widest">
                                Call 604-671-4247
                            </a>
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <p className="eyebrow text-bg/50 mb-5">Services</p>
                        <ul className="space-y-2 text-sm text-bg/80">
                            {services.slice(0, 6).map((s) => (
                                <li key={s.slug}><Link to={`/services/${s.slug}`} className="link-underline">{s.title}</Link></li>
                            ))}
                            <li><Link to="/services" className="link-underline text-bg">All services →</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <p className="eyebrow text-bg/50 mb-5">Industries</p>
                        <ul className="space-y-2 text-sm text-bg/80">
                            {industries.slice(0, 5).map((i) => (
                                <li key={i.slug}><Link to={`/industries/${i.slug}`} className="link-underline">{i.title}</Link></li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <p className="eyebrow text-bg/50 mb-5">Company</p>
                        <ul className="space-y-2 text-sm text-bg/80">
                            <li><Link to="/about" className="link-underline">About</Link></li>
                            <li><Link to="/projects" className="link-underline">Projects</Link></li>
                            <li><Link to="/resources" className="link-underline">Resources</Link></li>
                            <li><Link to="/service-areas" className="link-underline">Service Areas</Link></li>
                            <li><Link to="/faq" className="link-underline">FAQ</Link></li>
                            <li><Link to="/admin/login" className="link-underline text-bg/50">Admin</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="pt-8 flex flex-col md:flex-row gap-6 md:items-center justify-between text-xs text-bg/60 font-mono tracking-widest uppercase">
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
                        <span>© {new Date().getFullYear()} Final Cut Technologies · Metro Vancouver, BC</span>
                        <a href="tel:+16046714247" className="text-gold hover:text-bg transition-colors">Tel · 604-671-4247</a>
                    </div>
                    <div className="flex gap-6">
                        <Link to="/privacy" className="hover:text-bg">Privacy</Link>
                        <Link to="/terms" className="hover:text-bg">Terms</Link>
                        <span>The technology partner behind better-run businesses.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
